import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  header: {
    display: 'flex',
    margin: '35px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '22px',
    lineHeight: '22px',
    color: '#393B3F',
    mixBlendMode: 'normal',
    opacity: 0.7
  }
}));


export const WizardHeader = ({ title }: { title: string }) => {
  const classes = useStyles();
  return (
    <div className={classes.header}>
      <span>{title}</span>
    </div>
  );
};
